import { PropTypes } from "prop-types";

import SignInCta from "@/view/ViewPageError/SignInCta";
import SignUpCta from "@/view/ViewPageError/SignUpCta";
import { containerCss } from "./SignUpLogInCta.style";

const propTypes = {
  css: PropTypes.string,
  className: PropTypes.string,
};

const UnauthenticatedCallToActionArea = ({ css, className }) => (
  <div css={[css, containerCss]} className={className}>
    <SignUpCta />
    <SignInCta />
  </div>
);

UnauthenticatedCallToActionArea.propTypes = propTypes;
export default UnauthenticatedCallToActionArea;
